module.exports = __webpack_public_path__ + "img/ViolenceSendInvitations.e4220288.svg";